import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, createSlots as _createSlots, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 2,
  class: "mask-grand-access"
}
const _hoisted_2 = { class: "fixed bottom-1 right-2 text-[10px] text-gray-400 font-sans z-50 select-none pointer-events-none" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WrongTenantRedirectModal = _resolveComponent("WrongTenantRedirectModal")!
  const _component_DynamicModal = _resolveComponent("DynamicModal")!
  const _component_SettingTeamsModal = _resolveComponent("SettingTeamsModal")!
  const _component_DeviceSettingModal = _resolveComponent("DeviceSettingModal")!
  const _component_LoadingPage = _resolveComponent("LoadingPage")!
  const _component_NotFoundPage = _resolveComponent("NotFoundPage")!
  const _component_AppHeader = _resolveComponent("AppHeader")!
  const _component_AccessDeniedPage = _resolveComponent("AccessDeniedPage")!
  const _component_AppFooter = _resolveComponent("AppFooter")!
  const _component_MainLayout = _resolveComponent("MainLayout")!
  const _component_CookieConsentBanner = _resolveComponent("CookieConsentBanner")!
  const _component_BlockedBrowser = _resolveComponent("BlockedBrowser")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Spin = _resolveComponent("Spin")!
  const _component_LostConnectionWarning = _resolveComponent("LostConnectionWarning")!
  const _component_Toast = _resolveComponent("Toast")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_WrongTenantRedirectModal),
    _createVNode(_component_DynamicModal),
    _createVNode(_component_SettingTeamsModal),
    _createVNode(_component_DeviceSettingModal),
    (_ctx.appView === _ctx.AppView.Blank)
      ? (_openBlock(), _createBlock(_component_LoadingPage, { key: 0 }))
      : (_ctx.appView === _ctx.AppView.NotFound)
        ? (_openBlock(), _createBlock(_component_NotFoundPage, { key: 1 }))
        : (_ctx.appView === _ctx.AppView.UnAuthorized)
          ? (_openBlock(), _createBlock(_component_MainLayout, { key: 2 }, {
              header: _withCtx(() => [
                _createVNode(_component_AppHeader, { title: _ctx.siteTitle }, null, 8, ["title"])
              ]),
              footer: _withCtx(() => [
                _createVNode(_component_AppFooter)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_AccessDeniedPage)
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_MainLayout, { key: 3 }, _createSlots({
              default: _withCtx(() => [
                _createVNode(_component_CookieConsentBanner),
                (_ctx.isBrowserBlocked)
                  ? (_openBlock(), _createBlock(_component_BlockedBrowser, {
                      key: 0,
                      "is-desktop": _ctx.isDesktopBrowser
                    }, null, 8, ["is-desktop"]))
                  : (_openBlock(), _createBlock(_component_router_view, {
                      key: _ctx.$route.fullPath
                    })),
                (_ctx.isMaskGrandAccess)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                      _createVNode(_component_Spin, { class: "ant-custom-home" })
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_LostConnectionWarning)
              ]),
              _: 2
            }, [
              (_ctx.isHeaderVisible)
                ? {
                    name: "header",
                    fn: _withCtx(() => [
                      _createVNode(_component_AppHeader, { title: _ctx.siteTitle }, null, 8, ["title"])
                    ]),
                    key: "0"
                  }
                : undefined,
              (_ctx.isFooterVisible)
                ? {
                    name: "footer",
                    fn: _withCtx(() => [
                      _createVNode(_component_AppFooter)
                    ]),
                    key: "1"
                  }
                : undefined
            ]), 1024)),
    _createVNode(_component_Toast),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.versionUpdatedText), 1)
  ], 64))
}